import Error from "@/pages/Error.vue";
import Name from "./NameEnum";
import Otp from "@/pages/Otp.vue";
import PasswordSet from "@/pages/PasswordSet.vue";
import Path from "./PathEnum";
import Phone from "@/pages/Phone.vue";
import Result from "@/pages/Result.vue";
import VerifyPhone from "@/pages/VerifyPhone.vue";
import Vue from "vue";
import VueRouter, { Route, RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: Path.PASSWORD_SET,
        name: Name.PASSWORD_SET,
        component: PasswordSet
    },
    {
        path: Path.OTP,
        name: Name.OTP,
        component: Otp,
        props: true
    },
    {
        path: Path.ERROR,
        name: Name.ERROR,
        component: Error,
        props: true
    },
    {
        path: Path.PHONE,
        name: Name.PHONE,
        component: Phone
    },
    {
        path: Path.VERIFY_PHONE,
        name: Name.VERIFY_PHONE,
        component: VerifyPhone
    },
    {
        path: Path.RESULT,
        name: Name.RESULT,
        component: Result
    }
];

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach((to: Route, from: Route, next: Function) => {
    document.title = Vue.prototype.$localize("pwd.set.page_title");
    next();
});

export default router;
